"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _helpers = require("@/helpers");
var _underLoading = require("../helpers/under-loading");
var _extract = _interopRequireDefault(require("@/services/extract.service"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var state = {};
var mutations = {};
var getters = {};
var actions = {
  fetchExtractRequestsService: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref, _ref2) {
      var commit, month, year, asset, params, BU, _yield$ExtractService, data, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            commit = _ref.commit;
            month = _ref2.month, year = _ref2.year, asset = _ref2.asset, params = _ref2.params, BU = _ref2.BU;
            _context.p = 1;
            _context.n = 2;
            return _extract.default.fetchExtractRequestsService(month, year, asset, BU, params);
          case 2:
            _yield$ExtractService = _context.v;
            data = _yield$ExtractService.data;
            return _context.a(2, data);
          case 3:
            _context.p = 3;
            _t = _context.v;
            _helpers.errorResponseHelper.display(_t);
            return _context.a(2, false);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }()),
  fetchTotalRequestService: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref4, _ref5) {
      var commit, id, params, _yield$ExtractService2, data, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            commit = _ref4.commit;
            id = _ref5.id, params = _ref5.params;
            _context2.p = 1;
            _context2.n = 2;
            return _extract.default.fetchTotalRequestService(id, params);
          case 2:
            _yield$ExtractService2 = _context2.v;
            data = _yield$ExtractService2.data;
            return _context2.a(2, data);
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            _helpers.errorResponseHelper.display(_t2);
            return _context2.a(2, false);
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return function (_x3, _x4) {
      return _ref6.apply(this, arguments);
    };
  }()),
  fetchExtractRequestsServiceByConsumer: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref7, _ref8) {
      var commit, month, year, asset, params, BU, _yield$ExtractService3, data, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            commit = _ref7.commit;
            month = _ref8.month, year = _ref8.year, asset = _ref8.asset, params = _ref8.params, BU = _ref8.BU;
            _context3.p = 1;
            _context3.n = 2;
            return _extract.default.fetchExtractRequestsServiceByConsumer(month, year, asset, BU, params);
          case 2:
            _yield$ExtractService3 = _context3.v;
            data = _yield$ExtractService3.data;
            return _context3.a(2, data);
          case 3:
            _context3.p = 3;
            _t3 = _context3.v;
            _helpers.errorResponseHelper.display(_t3);
            return _context3.a(2, false);
        }
      }, _callee3, null, [[1, 3]]);
    }));
    return function (_x5, _x6) {
      return _ref9.apply(this, arguments);
    };
  }()),
  createDocumentExtractFinancial: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_ref0, payload) {
      var commit, _t4;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            commit = _ref0.commit;
            _context4.p = 1;
            _context4.n = 2;
            return _extract.default.createDocumentExtractFinancial(payload);
          case 2:
            return _context4.a(2, true);
          case 3:
            _context4.p = 3;
            _t4 = _context4.v;
            _helpers.errorResponseHelper.display(_t4);
            return _context4.a(2, false);
        }
      }, _callee4, null, [[1, 3]]);
    }));
    return function (_x7, _x8) {
      return _ref1.apply(this, arguments);
    };
  }()),
  fetchExtractDocumentsFinancials: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(_ref10, _ref11) {
      var commit, asset, BU, _yield$ExtractService4, data, _t5;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            commit = _ref10.commit;
            asset = _ref11.asset, BU = _ref11.BU;
            _context5.p = 1;
            _context5.n = 2;
            return _extract.default.fetchExtractDocumentsFinancials(asset, BU);
          case 2:
            _yield$ExtractService4 = _context5.v;
            data = _yield$ExtractService4.data;
            return _context5.a(2, data);
          case 3:
            _context5.p = 3;
            _t5 = _context5.v;
            _helpers.errorResponseHelper.display(_t5);
            return _context5.a(2, false);
        }
      }, _callee5, null, [[1, 3]]);
    }));
    return function (_x9, _x0) {
      return _ref12.apply(this, arguments);
    };
  }()),
  fetchGenerateExtractDocument: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(_ref13, _ref14) {
      var commit, asset, BU, month, year, _yield$ExtractService5, data, _t6;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            commit = _ref13.commit;
            asset = _ref14.asset, BU = _ref14.BU, month = _ref14.month, year = _ref14.year;
            _context6.p = 1;
            _context6.n = 2;
            return _extract.default.fetchGenerateExtractDocumentDigital(asset, BU, month, year);
          case 2:
            _yield$ExtractService5 = _context6.v;
            data = _yield$ExtractService5.data;
            return _context6.a(2, data);
          case 3:
            _context6.p = 3;
            _t6 = _context6.v;
            _helpers.errorResponseHelper.display(_t6);
            return _context6.a(2, false);
        }
      }, _callee6, null, [[1, 3]]);
    }));
    return function (_x1, _x10) {
      return _ref15.apply(this, arguments);
    };
  }()),
  downloadExtractDocumentsFinancial: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(_ref16, id) {
      var commit, _yield$ExtractService6, data, _t7;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            commit = _ref16.commit;
            _context7.p = 1;
            _context7.n = 2;
            return _extract.default.downloadExtractDocumentsFinancial(id);
          case 2:
            _yield$ExtractService6 = _context7.v;
            data = _yield$ExtractService6.data;
            return _context7.a(2, data);
          case 3:
            _context7.p = 3;
            _t7 = _context7.v;
            _helpers.errorResponseHelper.display(_t7);
            return _context7.a(2, false);
        }
      }, _callee7, null, [[1, 3]]);
    }));
    return function (_x11, _x12) {
      return _ref17.apply(this, arguments);
    };
  }())
};
var _default = exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};